import { AuthService } from '../services/AuthService';

export class ModeSelection {
  private container: HTMLElement;
  private authService: AuthService;
  private onModeSelect: (mode: 'single' | 'multi') => void;

  constructor(
    container: HTMLElement,
    authService: AuthService,
    onModeSelect: (mode: 'single' | 'multi') => void
  ) {
    this.container = container;
    this.authService = authService;
    this.onModeSelect = onModeSelect;
    
    this.render();
  }

  private render(): void {
    const user = this.authService.getCurrentUser();
    const loginStatus = user ? 
      `ログイン中: ${user.displayName}` : 
      'ログインなしでプレイ中';
    
    this.container.innerHTML = `
      <div class="mode-selection">
        <div class="mode-header">
          <h1>チムドンミニ</h1>
          <p class="subtitle">モードを選択してください</p>
          <div class="login-status">${loginStatus}</div>
        </div>
        
        <div class="mode-cards">
          <div class="mode-card single" id="single-mode">
            <div class="mode-icon">🎮</div>
            <h2>シングルプレイ</h2>
            <p class="mode-description">
              1人でじっくり遊ぶモード<br>
              自己ベストを更新しよう！
            </p>
            <ul class="mode-features">
              <li>✓ 6ラウンドのパズルゲーム</li>
              <li>✓ オンラインランキング対応</li>
              <li>✓ タイムアタック</li>
            </ul>
            <button class="mode-button">プレイ開始</button>
          </div>
          
          <div class="mode-card multi" id="multi-mode">
            <div class="mode-icon">👥</div>
            <h2>マルチプレイ</h2>
            <p class="mode-description">
              最大4人で競争！<br>
              同じ盤面で早解き対決
            </p>
            <ul class="mode-features">
              <li>✓ リアルタイム対戦</li>
              <li>✓ 同一盤面での競争</li>
              <li>✓ スコア＆タイム競争</li>
            </ul>
            <button class="mode-button">ロビーへ</button>
          </div>
        </div>
        
        <div class="mode-info">
          ${!user ? `
            <div class="login-prompt">
              <p>💡 ログインすると記録が保存され、ランキングに参加できます</p>
              <button id="login-btn" class="btn-login">ログイン / 新規登録</button>
            </div>
          ` : ''}
        </div>
      </div>
    `;
    
    this.attachEventListeners();
  }

  private attachEventListeners(): void {
    const singleMode = document.getElementById('single-mode');
    const multiMode = document.getElementById('multi-mode');
    const loginBtn = document.getElementById('login-btn');
    
    singleMode?.addEventListener('click', () => {
      this.onModeSelect('single');
    });
    
    multiMode?.addEventListener('click', () => {
      this.onModeSelect('multi');
    });
    
    loginBtn?.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent('show-login'));
    });
  }

  public updateLoginStatus(): void {
    this.render();
  }
}